import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'main',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ProfilePageSA'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ProfilePageSA'),
  },
  {
    path: '/staffing',
    name: 'staffing',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/StaffingPage'),
  },
  {
    path: '/clinicians',
    name: 'clinicians',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/CliniciansPage'),
  },
  {
    path: '/agencies',
    name: 'agencies',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/AgenciesPage'),
  },
  {
    path: '/dictionaries',
    name: 'dictionaries',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/DictionariesPage'),
  },
  {
    path: '/visits',
    name: 'visits',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/visits/VisitsPageSA'),
  },
  {
    path: '/visits/new-offer',
    name: 'visits.new-offer',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/visits/edit-offer/:offerId',
    name: 'visits.edit-offer',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/chats',
    name: 'chats',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ChatsPage'),
  },
  {
    path: '/documents',
    name: 'documents',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/DocumentsPage'),
  },
  {
    path: '/patients',
    name: 'patients',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/patients/PatientsPage'),
  },
  {
    path: '/patients/new',
    name: 'patients.new',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/NewPatientPage'),
  },
  {
    path: '/patients/edit/:uuid',
    name: 'patients.edit',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/NewPatientPage'),
  },
  {
    path: '/patients/:uuid',
    name: 'patient-details',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/PatientDetailsPage'),
  },
  {
    path: '/patients/:uuid/offers/new',
    name: 'patients.offers.new',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'staff-auth' },
    component: () => import('../views/health/auth/SignInForm'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: { layout: 'staff-auth' },
    component: () => import('../views/health/auth/ForgotPassForm'),
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { layout: 'staff-auth' },
    component: () => import('../views/health/auth/ResetPassForm'),
  },
  {
    path: '/set-password',
    name: 'set-password',
    meta: { layout: 'staff-auth' },
    component: () => import('../views/health/auth/ResetPassForm'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.auth.status.loggedIn
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: 'login' })
  } else if (to.path == '/') {
    next({ name: 'profile' })
  } else {
    next()
  }
})

export default router
